'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dPolicies$002dPage$0024 from "./presto.-List-Policies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479 from "./presto.-Presto-Router$$anon$79.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$78() {
  this.bmt = null;
  this.bml = null;
  this.bmm = false;
  this.bmu = null;
  this.bmv = false;
  this.bmy = null;
  this.bmr = null;
  this.bms = false;
  this.bmn = null;
  this.bmo = false;
  this.bmp = null;
  this.bmq = false;
  this.bmw = false;
  this.bmx = false;
  this.bmt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmy = "ListPoliciesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$78 as $c_Lpresto_PrestoRouter$$anon$78 };
$p = $c_Lpresto_PrestoRouter$$anon$78.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$78;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$78() {
}
export { $h_Lpresto_PrestoRouter$$anon$78 as $h_Lpresto_PrestoRouter$$anon$78 };
$h_Lpresto_PrestoRouter$$anon$78.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bmt;
});
$p.M = (function() {
  if ((!this.bmm)) {
    this.bml = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmm = true;
  }
  return this.bml;
});
$p.O = (function() {
  if ((!this.bmv)) {
    this.bmu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmv = true;
  }
  return this.bmu;
});
$p.E = (function() {
  return this.bmy;
});
$p.t = (function() {
  if ((!this.bms)) {
    this.bmr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bms = true;
  }
  return this.bmr;
});
$p.N = (function() {
  if ((!this.bmo)) {
    this.bmn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmo = true;
  }
  return this.bmn;
});
$p.Q = (function() {
  if ((!this.bmq)) {
    this.bmp = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479.$c_Lpresto_PrestoRouter$$anon$79();
    this.bmq = true;
  }
  return this.bmp;
});
$p.v = (function() {
  if ((!this.bmx)) {
    this.bmw = false;
    this.bmx = true;
  }
  return this.bmw;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee528) => ((p) => \u03b4scrutinee528))($j_presto$002e$002dList$002dPolicies$002dPage$0024.$m_Lpresto_ListPoliciesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$78 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$78, "presto.PrestoRouter$$anon$78", ({
  OV: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$78 as $d_Lpresto_PrestoRouter$$anon$78 };
//# sourceMappingURL=presto.-Presto-Router$$anon$78.js.map
